/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, useCallback, useEffect, useState } from 'react'
import { useSentry } from '../providers/sentry';

type Destructor = () => void;
type AsyncEffectCallback = () => Promise<void | Destructor>;

export function useAsyncEffect(effect: AsyncEffectCallback, deps?: DependencyList) {
  const [loading, setLoading] = useState(true)
  const [refreshing, setRefreshing] = useState(false)
  const [error, setError] = useState<Error>()
  const Sentry = useSentry()

  useEffect(useCallback(() => {
    // restart the callback sequence
    setError(undefined)
    setRefreshing(true)

    let destructor: Destructor | undefined = undefined
    let cancelled = false

    // init the callback
    effect()
      .then(
        (voidOrDestructor) => {
          // The jsdom environment can already be gone when a test file ends
          // while this promise is still settling. Setting state then throws
          // `window is not defined` and fails the run.
          if (cancelled || typeof window === 'undefined') {
            return
          }
          setLoading(false)
          setRefreshing(false)
          setError(undefined)
          if (voidOrDestructor) {
            destructor = voidOrDestructor
          }
        },
        (err) => {
          if (cancelled || typeof window === 'undefined') {
            return
          }
          setLoading(false)
          setRefreshing(false)
          setError(err)
          Sentry.captureException(err)
        })

    return () => {
      cancelled = true
      if (destructor) {
        destructor()
      }
    }
  }, deps || []), deps || [])

  return {loading, refreshing, error} as const
}
